import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Facebook,
  Twitter,
  Instagram,
} from "lucide-react";  // ✅ Lucide Icons
import tanuragalogo from "../assets/images/tanuraga-logo.png";
import axios from "axios";
import { apiUrl } from "../config/Config";


const Footer = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");
  const [submitting, setSubmitting] = useState(false);

  const handleSubscribe = async (event) => {
    event.preventDefault();
    const nextEmail = email.trim();

    if (!nextEmail) {
      setMessage("Please enter your email address.");
      setMessageType("error");
      return;
    }

    setSubmitting(true);
    setMessage("");
    setMessageType("");

    await axios
      .post(
        apiUrl + "subscribenewsletter",
        { email: nextEmail },
        { headers: { "Content-Type": "application/json" } }
      )
      .then((res) => {
        setMessage(res.data.message || "Subscribed successfully.");
        setMessageType(res.data.status === "success" ? "success" : "error");
        if (res.data.status === "success") {
          setEmail("");
        }
      })
      .catch((err) => {
        setMessage(err?.response?.data?.message || err.message || "Unable to subscribe right now.");
        setMessageType("error");
      });

    setSubmitting(false);
  };

  return (
   <div>
     <div className="footer-page">
      <div className="footer-container">

        <div className="footer-col footer-company">
          <img src={tanuragalogo} alt="PickBazar" className="footer-logo" />
          <address className="footer-address">
          H 309, Purva graces Amruthalli,<br />Hebbal, bengluru, 560092, Karnataka.
          </address>
          <p className="footer-contact">tanuraaga.weaves@gmail.com</p>
          <p className="footer-contact">+91 7411134054</p>
        </div>

        <div className="footer-col">
          <p className="footer-title">Explore</p>
          <Link to="/">Home</Link>
          <Link to="/about">About Us</Link>
          <Link to="/contact">Contact Us</Link>
        </div>

        <div className="footer-col">
          <p className="footer-title">Customer Service</p>
          <Link to="/faq">FAQ & Helps</Link>
          <Link to="/customer-refund-policies">Customer Refund Policies</Link>
        </div>

        <div className="footer-col">
          <p className="footer-title">Our Information</p>
          <Link to="/disclaimer">Disclaimer</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/termsconditions">Terms & conditions</Link>
        </div>

        <div className="footer-col footer-subscribe">
          <p className="footer-title">Subscribe Now</p>
          <p className="footer-text">
            Subscribe your email for newsletter and featured news and products
            based on your interest.
          </p>
          <form className="footer-input-box" onSubmit={handleSubscribe}>
            <input
              type="email"
              placeholder="Write your email here"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              disabled={submitting}
            />
            <button className="footer-send-btn" type="submit" disabled={submitting} aria-label="Subscribe">
              {submitting ? "..." : "➤"}
            </button>
          </form>
          {message && (
            <p className={`footer-subscribe-message ${messageType}`}>
              {message}
            </p>
          )}
          {/* ✅ Lucide Icons Used */}
          <div className="footer-socials">
            <Link to="#"><Facebook size={20} /></Link>
            <Link to="#"><Twitter size={20} /></Link>
            <Link to="#"><Instagram size={20} /></Link>
          </div>
        </div>

      </div>

      <div className="footer-bottom">
        ©2026 <b>Tanuraaga</b><sup>©</sup>.
        All rights reserved worldwide.
      </div>
    </div>
   </div>
  );
};

export default Footer;
